import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const PublicationList = Loadable(
  lazy(() => import("features/publication/components/List"))
);
const PublicationPage = Loadable(
  lazy(() => import("features/publication/components/Page"))
);

const routes = {
  path: "publication",
  children: [
    { path: "", element: <PublicationList /> },
    { path: "add", element: <PublicationPage /> },
    { path: "edit/:publicationId?", element: <PublicationPage /> },
  ],
};

export default routes;
